import React, { useState, useEffect, useRef } from "react";

interface CountdownTimerProps {
	duration: number; // Time in seconds
	onElapsed: () => void; // Callback when timer reaches zero
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
	duration,
	onElapsed,
}) => {
	const [timeLeft, setTimeLeft] = useState<number>(duration);
	const timerRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		if (timeLeft <= 0) {
			onElapsed();
			return;
		}

		timerRef.current = setInterval(() => {
			setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
		}, 1000);

		return () => {
			if (timerRef.current) clearInterval(timerRef.current);
		};
	}, [timeLeft, onElapsed]);

	// Ensure timeLeft is a valid number
	if (isNaN(timeLeft) || timeLeft < 0) {
		setTimeLeft(0);
	}

	// Format time dynamically based on remaining duration
	const formatTime = () => {
		if (timeLeft >= 3600) {
			const hours = Math.floor(timeLeft / 3600);
			const minutes = Math.floor((timeLeft % 3600) / 60);
			const seconds = timeLeft % 60;
			return `${String(hours).padStart(2, "0")}:${String(
				minutes
			).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
		} else if (timeLeft >= 60) {
			const minutes = Math.floor(timeLeft / 60);
			const seconds = timeLeft % 60;
			return `${String(minutes).padStart(2, "0")}:${String(
				seconds
			).padStart(2, "0")}`;
		} else {
			return `${String(timeLeft).padStart(2, "0")}`;
		}
	};

	return (
		<div className="text-center font-mono text-lg font-semibold text-gray-800 bg-gray-100 px-2 py-1 rounded-lg shadow-md">
			{formatTime()}
		</div>
	);
};

export default CountdownTimer;
